import React from 'react';
import {useAuth} from '@/context/AuthContext';
import ModuleTopNav from './ModuleTopNav';
export default function HubHeader(){const {user,logout}=useAuth();return <ModuleTopNav module="hub" title="Unified workspace" user={user} onLogout={logout} items={[{to:'/',label:'Overview',end:true},...(user?.role==='admin'?[{to:'/admin',label:'Administration'}]:[])]}/>}
